define.alias("@glimmer/component/-private/ember-component-manager", "settings/component-managers/glimmer");